/* Zuflah: desktop header menus open on hover (Zempire style).
   Click and keyboard keep Dawn's behaviour, but a click never closes a menu that hover just opened. */
(function () {
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');

  function setOpen(details, open) {
    if (open) details.setAttribute('open', ''); else details.removeAttribute('open');
    var s = details.querySelector('summary');
    if (s) s.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function bind() {
    document.querySelectorAll('.header__inline-menu > ul > li').forEach(function (li) {
      var details = li.querySelector('details');
      if (!details || li.dataset.zfHover) return;
      li.dataset.zfHover = '1';
      var summary = details.querySelector('summary');
      var closeTimer;

      li.addEventListener('mouseenter', function () {
        if (!fine.matches) return;
        clearTimeout(closeTimer);
        document.querySelectorAll('.header__inline-menu details[open]').forEach(function (d) { if (d !== details) setOpen(d, false); });
        setOpen(details, true);
      });

      li.addEventListener('mouseleave', function () {
        if (!fine.matches) return;
        closeTimer = setTimeout(function () { setOpen(details, false); }, 200);
      });

      // With a mouse, clicking the top-level item keeps the menu open instead of toggling it shut.
      if (summary) {
        summary.addEventListener('click', function (e) {
          if (!fine.matches || e.detail === 0) return; // e.detail === 0 means keyboard activation
          e.preventDefault();
          setOpen(details, true);
        }, true);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
  document.addEventListener('shopify:section:load', bind);
})();
